/**
 * The line under the "Long-distance visit" tick (LP-46).
 *
 * tenants.config.payroll.long_distance_rule: one sentence, the tenant's
 * rule for which visits count (Peace's: "For travel over 40 minutes each
 * way."). The helper reads that sentence, then "Not charged to the
 * client."; with the key unset or malformed it reads "Not charged to the
 * client." alone. The helper never names money: Olive shows no amount to
 * a care manager or a therapist; the pay is the payroll system's, one
 * SPICE Travel line per ticked note.
 *
 * Read beside readPayrollConfig (src/lib/payPeriod.ts), not in it: that
 * module mirrors the server's byte for byte, and only the browser reads
 * this key. Pure, no I/O.
 */

const RULE_MAX_CHARS = 200;

export function readLongDistanceRule(config: unknown): string | null {
  if (typeof config !== 'object' || config === null) return null;
  const payroll = (config as Record<string, unknown>)['payroll'];
  if (typeof payroll !== 'object' || payroll === null) return null;
  const raw = (payroll as Record<string, unknown>)['long_distance_rule'];
  if (typeof raw !== 'string') return null;
  const rule = raw.trim();
  return rule.length > 0 && rule.length <= RULE_MAX_CHARS ? rule : null;
}

export const NOT_CHARGED = 'Not charged to the client.';

/** The line under the tick: the tenant's rule, when set, then the fixed close. */
export function longDistanceHelper(rule: string | null): string {
  return rule === null ? NOT_CHARGED : `${rule} ${NOT_CHARGED}`;
}
